var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#3955BF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.6,22.9H34.3v19c0,1.2-1,2.3-2.3,2.3c-1.2,0-2.3-1-2.3-2.3v-19H17.4C7.7,22.9,1.7,29,1.7,38.7v7.9 c0,9.7,6.1,15.8,15.8,15.8h29.1c9.7,0,15.8-6.1,15.8-15.8v-7.9C62.4,29,56.3,22.9,46.6,22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.3,9.4l6.3,6.3c0.5,0.5,1,0.7,1.6,0.7c0.6,0,1.2-0.2,1.6-0.7c0.9-0.9,0.9-2.3,0-3.2L33.6,2.3 c-0.9-0.9-2.3-0.9-3.2,0L20.2,12.5c-0.9,0.9-0.9,2.3,0,3.2c0.9,0.9,2.3,0.9,3.2,0l6.3-6.3v13.5h4.6V9.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.45113394f480a627e468d6c9383754b2.svg";
export { ForwardRef as ReactComponent };